<template>
  <el-drawer
    :visible.sync="data.visible"
    :size="600"
    direction="ltr"
    class="upload-drawer"
    :close-on-press-escape="false"
    :wrapperClosable="false"
    :show-close="false">
    <div class="up-drawer-wrapper">
      <div class="header">
        <span class="title">上传中，请勿关闭页面</span>
        <el-button type="danger" round @click="handleClick" v-if="data.faiNum>0" :loading="data.loading">关闭</el-button>
      </div>
      <el-radio-group v-model="tabPosition" :stretch="true" @change="handleTab" style="margin-bottom: 30px;width: 100%">
        <el-radio-button label="a">全部({{ data.list.length }})</el-radio-button>
        <el-radio-button label="b">上传中({{ data.ingNum }})</el-radio-button>
        <el-radio-button label="c">上传成功({{ data.sucNum }})</el-radio-button>
        <el-radio-button label="d">上传失败({{ data.faiNum }})</el-radio-button>
      </el-radio-group>
      <el-table
        style="min-height: 740px;"
        :data="tableData"
        stripe size="mini">
        <el-table-column prop="title" label="作品标题" :show-overflow-tooltip="true" width="180"></el-table-column>
        <el-table-column prop="spec" label="时长规格" width="90">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.spec === 0" type="info" size="mini"
              disable-transitions>正在计算..
            </el-tag>
            <el-tag
              type="success" size="mini"
              v-else-if="scope.row.spec<=180"
              disable-transitions>短视频
            </el-tag>
            <el-tag
              size="mini"
              v-else-if="scope.row.spec<=900"
              disable-transitions>长视频
            </el-tag>
            <el-tag
              type="warning" size="mini"
              v-else
              disable-transitions>大视频
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="score" label="图片得分" width="90"></el-table-column>
        <el-table-column prop="percent" label="进度">
          <template slot-scope="scope">
            {{ scope.row.result }}
            <el-progress :percentage="scope.row.percent" :status="scope.row.status"></el-progress>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-drawer>
</template>

<script>
export default {
  props: {
    data: {
      visible: false,
      loading: false,
      list: [],
      ingList: [],
      sucList: [],
      failList: [],
      ingNum: 0,
      sucNum: 0,
      faiNum: 0
    }
  },
  watch: {
    dataList () {
      console.log(this.dataList)
      this.tableData = this.dataList
    }
  },
  computed: {
    dataList () { return this.data.list }
  },
  data () {
    return {
      tabPosition: 'a',
      tableData: []
    }
  },
  methods: {
    handleClick (e) {
      this.$emit('close', e)
    },
    handleTab (e) {
      switch (e) {
        case 'a':
          this.tableData = this.data.list
          break
        case 'b':
          this.tableData = this.data.ingList
          break
        case 'c':
          this.tableData = this.data.sucList
          break
        case 'd':
          this.tableData = this.data.failList
          break
      }
    }
  }
}
</script>

<style>
.el-drawer__header {
  margin-bottom: 0px;
  padding: 0px;
}

.up-drawer-wrapper {
  padding: 0 20px;
  width: 100%;
  font-size: 14px;
}

.up-drawer-wrapper .header {
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
}

.up-drawer-wrapper .header .title {
  font-size: 16px;
  font-weight: 600;
  line-height: 40px;
}

.up-drawer-wrapper .el-radio-button {
  width: 25%;
}

.up-drawer-wrapper .el-radio-button__inner {
  width: 100%;
}

.up-drawer-wrapper .el-table {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/UploadDrawer.vue